export const SITE_URL = 'https://www.healthgrow.online';
export const SITE_NAME = 'Health Grow';
export const APK_DOWNLOAD_URL =
  'https://github.com/Kalpesh-Mina/website/releases/download/V3.00/Health-Grow.apk';
export const CONTACT_EMAIL = 'healthgrow.in@gmail.com';

export const DEFAULT_TITLE = 'Health Grow | Health app for India — reminders, vitals & AI reports';
export const DEFAULT_DESCRIPTION =
  'Health Grow is a free Android health app for India: medicine reminders, heart-rate tracking, AI lab report explanations, secure health document vault, and emergency alerts to trusted contacts.';

export const KEYWORDS =
  'health grow, health grow app, health app india, medication reminder app india, medicine reminder app, heart rate app android, health report ai india, emergency health alert app, android health app india';
